module.exports = __webpack_public_path__ + "a07308dede5c107e96bf63f4f9570bda.svg";